import React from 'react';

import { Col, Divider, Row, Space } from 'antd';
import { isEmpty, groupBy, get, isNil, isNumber, isString, min } from 'lodash';
import CheckingItem from './components/CheckingItem';
import TotalDefect from './components/DefectTotal';
import { InfoLine, Status, TitleField } from './components/Elements';
import PackingMarkingItem from './components/PackingMarkingItem';
import ReferenceMedia from './components/ReferenceMedia';
import { IShippingInformation } from 'app/types/interfaces/Product';
export const SectionFields: {
  [x: string]: any;
} = {
  quantityAvailable: [
    {
      dataIndex: 'bookQuantity',
      label: 'Book Qty:', //orderQty
      render: (value: any, field: any, _: any[], sectionKey: string) => {
        const { poItem } = value;
        return (
          <InfoLine
            key={`${sectionKey}_quantityAvailable_${field.dataIndex}`}
            label={field.label}
            value={poItem?.orderQty}
          ></InfoLine>
        );
      }
    },
    {
      dataIndex: 'requestProduced',
      label: 'Request Produced %:',
      render: (value: any, field: any, _: any[], sectionKey: string) => {
        return (
          <InfoLine
            key={`${sectionKey}_quantityAvailable_${field.dataIndex}`}
            label={field.label}
            value={`${value[field.dataIndex]}%`}
          ></InfoLine>
        );
      }
    },
    {
      dataIndex: 'producedQuantity',
      label: 'Produced Qty:',
      render: (value: any, __: any, _: any[], sectionKey: string) => {
        const {
          producedQuantity,
          poItem,
          requestProduced,
          producedPercentage
        } = value;
        const numberRequestProduced = isNaN(parseInt(requestProduced))
          ? 0
          : parseInt(requestProduced);
        const numberProducedQuantity = isNaN(parseInt(producedPercentage || 0))
          ? 0
          : parseInt(producedPercentage);

        const status =
          numberProducedQuantity >= numberRequestProduced ? 'passed' : 'failed';
        return (
          <Space key={`${sectionKey}_quantityAvailable_producedQuantity`}>
            <InfoLine
              label="Produced Qty:"
              value={`${producedQuantity || 0}/${poItem?.orderQty ?? 0}`}
            ></InfoLine>

            <InfoLine
              label="Product %:"
              value={
                <Status
                  status={status}
                  renderLabel={() => {
                    return `${producedPercentage || 0} %`;
                  }}
                ></Status>
              }
            ></InfoLine>
          </Space>
        );
      }
    },
    {
      dataIndex: 'requestPacked',
      label: 'Request Packed %:',
      render: (value: any, field: any, _: any[], sectionKey: string) => {
        return (
          <InfoLine
            key={`${sectionKey}_quantityAvailable_${field.dataIndex}`}
            label={field.label}
            value={`${value[field.dataIndex]}%`}
          ></InfoLine>
        );
      }
    },
    {
      dataIndex: 'packedQuantity',
      label: 'Packed Qty:',
      render: (value: any, __: any, _: any[], sectionKey: string) => {
        const { packedQuantity, poItem, requestPacked, packedPercentage } =
          value;

        const numberRequestProduced = isNaN(parseInt(requestPacked))
          ? 0
          : parseInt(requestPacked);

        const numberPackedQuantity = isNaN(parseInt(packedPercentage || 0))
          ? 0
          : parseInt(packedPercentage);

        const status =
          numberPackedQuantity > numberRequestProduced ? 'passed' : 'failed';
        return (
          <Space key={`${sectionKey}_quantityAvailable_packedQuantity`}>
            <InfoLine
              label="Packed Qty:"
              value={`${packedQuantity || 0}/${poItem?.orderQty ?? 0}`}
            ></InfoLine>

            <InfoLine
              label="Packed %:"
              value={
                <Status
                  status={status}
                  renderLabel={() => {
                    return `${packedPercentage || 0} %`;
                  }}
                ></Status>
              }
            ></InfoLine>
          </Space>
        );
      }
    },
    {
      dataIndex: 'referenceMedia',
      label: 'Reference Media:',
      render: (value: any, field: any, _: any[], sectionKey: string) => {
        return (
          <ReferenceMedia
            media={get(value, field.dataIndex, [])}
            key={`${sectionKey}_quantityAvailable_${field.dataIndex}`}
          ></ReferenceMedia>
        );
      }
    }
  ], // ["producedQty","packedQty","referenceMedia","remark"]
  productDescriptionStyleColor: [
    {
      dataIndex: 'signedSampleAvailable',
      label: 'Signed Sample available:',
      render: (value: any, field: any, _: any[], sectionKey: string) => {
        const { signedSampleAvailable } = value;
        const label = !signedSampleAvailable
          ? 'N/A'
          : signedSampleAvailable === 'yes'
          ? 'Yes'
          : 'No';
        return (
          <InfoLine
            key={`${sectionKey}_productDescriptionStyleColor_${field.dataIndex}`}
            label="Signed Sample available:"
            value={label}
          ></InfoLine>
        );
      }
    },
    {
      dataIndex: 'appearance',
      label: 'Appearance',
      render: (value: any, field: any, _: any[], sectionKey: string) => {
        const { appearance } = value;
        const status = appearance === 'conformed' ? 'passed' : 'failed';
        const label = isEmpty(appearance)
          ? 'N/A'
          : appearance === 'conformed'
          ? 'Conformed'
          : 'Not Conform';
        return (
          <InfoLine
            key={`${sectionKey}_productDescriptionStyleColor_${field.dataIndex}`}
            label="Appearance: "
            value={
              <Status
                status={isEmpty(appearance) ? 'default' : status}
                renderLabel={() => {
                  return `${label}`;
                }}
              ></Status>
            }
          ></InfoLine>
        );
      }
    },
    {
      dataIndex: 'accessories',
      label: 'Accessories:',
      render: (value: any, field: any, _: any[], sectionKey: string) => {
        const { accessories } = value;
        const status = accessories === 'conformed' ? 'passed' : 'failed';
        const label = isEmpty(accessories)
          ? 'N/A'
          : accessories === 'conformed'
          ? 'Conformed'
          : 'Not Conform';
        return (
          <InfoLine
            key={`${sectionKey}_productDescriptionStyleColor_${field.dataIndex}`}
            label="Accessories: "
            value={
              <Status
                status={isEmpty(accessories) ? 'default' : status}
                renderLabel={() => {
                  return `${label}`;
                }}
              ></Status>
            }
          ></InfoLine>
        );
      }
    },
    {
      dataIndex: 'material',
      label: 'Material:',
      render: (value: any, field: any, _: any[], sectionKey: string) => {
        const { material } = value;
        const status = material === 'conformed' ? 'passed' : 'failed';
        const label = isEmpty(material)
          ? 'N/A'
          : material === 'conformed'
          ? 'Conformed'
          : 'Not Conform';
        return (
          <InfoLine
            key={`${sectionKey}_productDescriptionStyleColor_${field.dataIndex}`}
            label="Material: "
            value={
              <Status
                status={isEmpty(material) ? 'default' : status}
                renderLabel={() => {
                  return `${label}`;
                }}
              ></Status>
            }
          ></InfoLine>
        );
      }
    },
    {
      dataIndex: 'package',
      label: 'Package:',
      render: (value: any, field: any, _: any[], sectionKey: string) => {
        const { package: productPackage } = value;
        const status = productPackage === 'conformed' ? 'passed' : 'failed';
        const label = isEmpty(productPackage)
          ? 'N/A'
          : productPackage === 'conformed'
          ? 'Conformed'
          : 'Not Conform';
        return (
          <InfoLine
            key={`${sectionKey}_productDescriptionStyleColor_${field.dataIndex}`}
            label="Package: "
            value={
              <Status
                status={isEmpty(productPackage) ? 'default' : (status as any)}
                renderLabel={() => {
                  return `${label}`;
                }}
              ></Status>
            }
          ></InfoLine>
        );
      }
    },
    {
      dataIndex: 'labelling',
      label: 'Labelling:',
      render: (value: any, field: any, _: any[], sectionKey: string) => {
        const { labelling } = value;
        const status = labelling === 'conformed' ? 'passed' : 'failed';
        const label = isEmpty(labelling)
          ? 'N/A'
          : labelling === 'conformed'
          ? 'Conformed'
          : 'Not Conform';
        return (
          <InfoLine
            key={`${sectionKey}_productDescriptionStyleColor_${field.dataIndex}`}
            label="Labelling: "
            value={
              <Status
                status={isEmpty(labelling) ? 'default' : (status as any)}
                renderLabel={() => {
                  return `${label}`;
                }}
              ></Status>
            }
          ></InfoLine>
        );
      }
    },
    {
      dataIndex: 'referenceMedia',
      label: 'Reference Media:',
      render: (value: any, field: any, _: any[], sectionKey: string) => {
        return (
          <ReferenceMedia
            media={get(value, field.dataIndex, [])}
            key={`${sectionKey}importantRemarksAttachments${field.dataIndex}`}
          ></ReferenceMedia>
        );
      }
    }
  ], //["signedSampleAvailable","appearance","accessories","material","package","labelling","referenceMedia","remark"]
  workmanship: [
    {
      dataIndex: 'defects',
      label: '',
      render: (value: any, field: any, _: any[], sectionKey: string) => {
        const groupedByClassification = groupBy(
          value.defects?.filter(({ quantity }) => {
            if (isNumber(quantity)) return quantity > 0;
            if (isString(quantity)) return Number(quantity) > 0;
            return !!quantity;
          }),
          'defectClassification'
        );

        return Object.keys(groupedByClassification)
          .sort()
          .map((key) => {
            const defects = groupedByClassification[key];
            return defects.map((defect, index) => {
              const prefix = defect.defectClassification
                ? `(${defect.defectClassification})`
                : '';
              return (
                <Space
                  key={`${sectionKey}_workmanship_${field.dataIndex}_${key}_${index}`}
                  style={{ marginBottom: 8, marginTop: 8 }}
                  // key={`${key}_${index}`}
                  direction="vertical"
                >
                  <InfoLine
                    label={`Defect`}
                    value={`${defect.defectGroup} - ${defect.defectName}${
                      prefix ? ` ${prefix}` : ''
                    }`}
                  ></InfoLine>
                  <InfoLine
                    label={`Quantity: `}
                    value={defect.quantity || 'N/A'}
                  ></InfoLine>
                  <InfoLine
                    label={`Description: `}
                    value={defect.description || 'N/A'}
                  ></InfoLine>
                  <ReferenceMedia
                    media={defect.referenceMedia}
                  ></ReferenceMedia>
                  {/* <InfoLine label={`Reference media:  `}></InfoLine> */}
                </Space>
              );
            });
          });
      }
    },
    {
      dataIndex: 'numberOfDefect',
      label: 'Total defect found',
      render: (value: any, field: any, _: any[], sectionKey: string) => {
        const groupedByClassification = groupBy(
          value.defects,
          'defectClassification'
        );
        let critical = 0;
        let minor = 0;
        let major = 0;
        (groupedByClassification.critical || []).forEach((defect) => {
          if (!isNil(defect.quantity)) {
            critical += parseInt(defect.quantity);
          }
        });
        (groupedByClassification.minor || []).forEach((defect) => {
          if (!isNil(defect.quantity)) {
            minor += parseInt(defect.quantity);
          }
        });
        (groupedByClassification.major || []).forEach((defect) => {
          if (!isNil(defect.quantity)) {
            major += parseInt(defect.quantity);
          }
        });
        return (
          <div
            style={{ width: '100%' }}
            key={`${sectionKey}_workmanship_${field.dataIndex}`}
          >
            <Divider style={{ marginTop: 12, marginBottom: 12 }}></Divider>
            <TitleField>Total defect found</TitleField>
            <TotalDefect
              label={'Total Defectives Found'}
              critical={critical || 0}
              major={major || 0}
              minor={minor || 0}
            ></TotalDefect>
          </div>
        );
      }
    },
    {
      dataIndex: 'requestByAQL',
      label: 'Request by AQL',
      render: (value: any, field: any, _: any[], sectionKey: string) => {
        // const groupedByClassification = groupBy(
        //   value.defects,
        //   'defectClassification'
        // );
        const { poItem } = value;
        const acceptanceAQL = {
          critical: get(poItem.aql, 'critical.acceptanceLevel', 0),
          major: get(poItem.aql, 'major.acceptanceLevel', 0),
          minor: get(poItem.aql, 'minor.acceptanceLevel', 0)
        };

        return (
          <div
            style={{ width: '100%' }}
            key={`${sectionKey}_workmanship_${field.dataIndex}`}
          >
            <TitleField>Request by AQL</TitleField>
            <TotalDefect
              label={'Defectives Accepted'}
              // critical={poItem.criticalLevel}
              // major={poItem.criticalMajorLevel}
              // minor={poItem.criticalMinorLevel}
              {...acceptanceAQL}
            ></TotalDefect>
          </div>
        );
      }
    },
    {
      dataIndex: 'result',
      label: 'Result',
      render: (value: any, field: any, _: any[], sectionKey: string) => {
        const { defects, poItem } = value;

        const groupByClassification = groupBy(
          defects || [],
          'defectClassification'
        );
        const total = Object.keys(groupByClassification).reduce(
          (acc: any, key) => {
            groupByClassification[key].forEach((defect) => {
              const { quantity } = defect;
              if (!isEmpty(quantity)) {
                acc[key] += parseInt(quantity);
              }
            });
            return acc;
          },
          { critical: 0, minor: 0, major: 0 }
        );
        const results = Object.keys(total).reduce(
          (acc, classification) => {
            const acceptanceAQL = {
              critical: get(poItem.aql, 'critical.acceptanceLevel', 0),
              major: get(poItem.aql, 'major.acceptanceLevel', 0),
              minor: get(poItem.aql, 'minor.acceptanceLevel', 0)
            };
            return {
              ...acc,
              [classification]:
                total[classification] > acceptanceAQL[classification]
                  ? 'failed'
                  : 'passed'
            };
          },
          {
            critical: 'pending',
            minor: 'pending',
            major: 'pending'
          }
        );
        return (
          <div
            style={{ width: '100%' }}
            key={`${sectionKey}_workmanship_${field.dataIndex}`}
          >
            <Row>
              <Col span={6}>
                <TitleField>Result</TitleField>
              </Col>
              <Col span={6} style={{ textAlign: 'center' }}>
                <Status status={results['critical'] as any}></Status>
              </Col>
              <Col span={6} style={{ textAlign: 'center' }}>
                <Status status={results['major'] as any}></Status>
              </Col>
              <Col span={6} style={{ textAlign: 'center' }}>
                <Status status={results['minor'] as any}></Status>
              </Col>
            </Row>
          </div>
        );
      }
    }
  ], //["signedSampleAvailable","defects"//total]
  onSiteTest: [
    {
      dataIndex: 'checkList',
      label: '',
      render: (value: any, field: any, _: any[], sectionKey: string) => {
        const { checkList } = value;
        if (!Array.isArray(checkList)) return null;

        return checkList.map((checkingItem, index) => {
          return (
            <CheckingItem
              title={`#${index + 1}. ${checkingItem?.checkPointName}`}
              checkItem={checkingItem}
              key={`${sectionKey}_checkList_${field.dataIndex}_${index}`}
            ></CheckingItem>
          );
        });
      }
    }
  ], //["checkList"]
  packingMarking: [
    {
      dataIndex: 'sellingUnitContent',
      label: '',
      render: (value: any, field: any, _: any[], sectionKey: string) => {
        const { shippingInformation } = value;
        const sellingUnit = (shippingInformation || []).find(
          ({ type }: IShippingInformation) => {
            return type === 'selling_unit';
          }
        );

        return (
          <PackingMarkingItem
            shippingInformation={sellingUnit || {}}
            value={value?.sellingUnitContent}
            key={`${sectionKey}_packingMarking_${field.dataIndex}`}
            title="Selling Unit"
          ></PackingMarkingItem>
        );
      }
    },
    {
      dataIndex: 'innerPackContent',
      label: '',
      render: (value: any, field: any, _: any[], sectionKey: string) => {
        const { shippingInformation, innerPackContent } = value;
        const innerCarton = (shippingInformation || []).find(
          ({ type }: IShippingInformation) => {
            return type === 'inner_carton';
          }
        );

        return (
          <PackingMarkingItem
            shippingInformation={innerCarton || {}}
            value={value?.innerPackContent}
            key={`${sectionKey}_packingMarking_${field.dataIndex}`}
            title={'Inner Pack'}
            extra={
              <>
                <InfoLine
                  label="Total Quantity / Inner Carton."
                  value={`${innerPackContent?.totalQuantity}`}
                ></InfoLine>
              </>
            }
          ></PackingMarkingItem>
        );
      }
    },
    {
      dataIndex: 'outerCartonContent',
      label: '',
      render: (value: any, field: any, _: any[], sectionKey: string) => {
        const { shippingInformation, outerCartonContent } = value;
        const outerCarton = (shippingInformation || []).find(
          ({ type }: IShippingInformation) => {
            return type === 'outer_carton';
          }
        );

        return (
          <PackingMarkingItem
            shippingInformation={outerCarton || {}}
            value={value?.outerCartonContent}
            key={`${sectionKey}_packingMarking_${field.dataIndex}`}
            title="Outer Pack"
            extra={
              <>
                <InfoLine
                  label="Total Quantity / Outer Carton."
                  value={`${outerCartonContent?.outerQuantity} `}
                ></InfoLine>
                <InfoLine
                  label="No. of Inner / Outer Carton"
                  value={`${outerCartonContent?.outerCarton} `}
                ></InfoLine>
              </>
            }
          ></PackingMarkingItem>
        );
      }
    }
  ], //["sellingUnitContent","innerPackContent","outerCartonContent","remark"]; section result calculated base one each of result in section.

  importantRemarksAttachments: [
    {
      dataIndex: 'attachments',
      label: 'Reference Media:',
      render: (value: any, field: any, _: any[], sectionKey: string) => {
        return (
          <ReferenceMedia
            media={get(value, field.dataIndex, [])}
            key={`${sectionKey}importantRemarksAttachments${field.dataIndex}`}
            title="Attachments:"
          ></ReferenceMedia>
        );
      }
    }
  ] //["remark",referenceMedia"]
};

export const isFieldRequired = (sectionName: string, field: any) => {
  const SECTION_FIELDS: {
    [x: string]: string[];
  } = {
    quantityAvailable: [
      'producedQuantity',
      'packedQuantity',
      'referenceMedia',
      'result',
      'remark'
    ],
    productDescriptionStyleColor: [
      'signedSampleAvailable',
      'appearance',
      'accessories',
      'material',
      'package',
      'labelling',
      'referenceMedia',
      'remark',
      'result'
    ],
    workmanship: ['signedSampleAvailable', 'defects', 'remark'],
    packingMarking: [
      'sellingUnitContent',
      'innerPackContent',
      'outerCartonContent',
      'remark'
    ],
    onSiteTest: ['checkList'],
    importantRemarksAttachments: ['remark', 'attachments'],
    sellingUnitContent: [
      'length',
      'width',
      'height',
      // 'actualBarcode',
      // 'actualNetWeight',
      // 'actualGrossWeight',
      'result'
      // 'remark',
      // 'referenceMedia'
    ],
    innerPackContent: [
      'length',
      'width',
      'height',
      // 'actualBarcode',
      // 'actualNetWeight',
      // 'actualGrossWeight',
      'result'
      // 'remark',
      // 'referenceMedia'
    ],
    outerCartonContent: [
      'length',
      'width',
      'height',
      // 'actualBarcode',
      // 'actualNetWeight',
      // 'actualGrossWeight',
      'result'
      // 'remark',
      // 'referenceMedia'
    ]
  };
  const section = SECTION_FIELDS[sectionName] || [];
  if (field.type === 'LIST') {
    return true; // default always required
  }

  return section.includes(field.name) && isEmpty(field.optional);
};
